// 대운 전환 유형(돕는 / 막는 / 바꾸는) 분류. 표는 luckTransitions.js (사용자 승인, 고서 원문 확인 전).
// 건록격·월겁격(별도)이나 대운 자료가 없으면 null 이다. 분류는 게임 규칙이며 고서의 수치가 아니다.
import { LUCK_TRANSITIONS } from './luckTransitions.js';

const TEN = ['비견', '겁재', '식신', '상관', '편재', '정재', '편관', '정관', '편인', '정인'];
const GYEOK_TEN = { 정관격: '정관', 편관격: '편관', 정인격: '정인', 편인격: '편인', 식신격: '식신', 상관격: '상관',
  정재격: '정재', 편재격: '편재', 양인격: '겁재' };
const groupIndex = (ten) => Math.floor(TEN.indexOf(ten) / 2);

let TABLE = LUCK_TRANSITIONS;
export const getTransitionTable = () => TABLE;
// 테스트용: 표를 바꾸거나(null 이면 표 없음) 승인된 표로 되돌린다.
export const setTransitionTable = (table) => { TABLE = table; };
export const resetTransitionTable = () => { TABLE = LUCK_TRANSITIONS; };

// 영역 번호 g 는 일간 오행에서 g 만큼 떨어진 오행이다. 생: g → g+1, 극: g → g+2.
export function relationOf(gyeokTen, ten) {
  if (gyeokTen === ten) return '같은십성';
  const x = groupIndex(gyeokTen), y = groupIndex(ten);
  if (x === y) return '같은그룹다른십성';
  if ((y + 1) % 5 === x) return '대운이격국을생';
  if ((y + 2) % 5 === x) return '대운이격국을극';
  if ((x + 1) % 5 === y) return '격국이대운을생';
  return '격국이대운을극';
}

/** 분류 상세: { type, relation, yong, overridden } — 표가 없거나 분류할 수 없으면(건록·월겁격 등) null. overridden 은 격국×십성 예외로 유형이 달라진 경우다. */
export function transitionDetail(essence, luck) {
  if (!TABLE || !essence || !luck?.ten) return null;
  const yong = essence.yong?.value;
  const gyeokTen = GYEOK_TEN[essence.gyeok?.value];
  if (!gyeokTen || (yong !== '순용' && yong !== '역용')) return null;
  const relation = relationOf(gyeokTen, luck.ten);
  const cellType = TABLE.table?.[yong]?.[relation]?.type ?? null;
  // 격국×십성 한 칸 단위 예외가 있으면 관계 표보다 먼저 쓴다.
  const override = TABLE.overrides?.[essence.gyeok.value]?.[luck.ten]?.type;
  const type = override ?? cellType;
  return type ? { type, relation, yong, overridden: !!override && override !== cellType } : null;
}

/** essence(본질)와 luck(luckAt 결과)으로 전환 유형을 돌려준다. 표가 없거나 별도(건록·월겁)면 null. */
export function classifyTransition(essence, luck) {
  return transitionDetail(essence, luck)?.type ?? null;
}
